import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
function ChatHistory() {
    const { isTheme } = useSelector((state) => state.currentStage)
    return (
        <div>
            <div className="filterdiv">
                <div className='chathistorydiv'>
                    <Link to="/user-chatbot">
                    {isTheme === "light" ? 
                      <img src="img/back-light.svg" alt="arrow" />
                    :
                      <img src="img/historyarrow.svg" alt="arrow" />
                }
                   
                    </Link>
                    <div>
                        {/* <h6 className='gis-title'>GIS AI</h6> */}
                        <h5 className='history-title m-0'>Chat History</h5>
                    </div>
                </div>
            </div>
            <div className='mainchathistorydiv'>
                <div className='row'>
                    <div className='col-lg-8 col-md-12'>
                        <h6 className='day-title mb-3'>Today</h6>
                        <div className='todaydiv'>
                            <div className='content'>
                                {isTheme === "light" ?  <img src="img/messenger-light.svg" alt="message" /> :  <img src="img/chatmessage.svg" alt="message" />}
                                <h6 className='m-0'>Show me water bodies near airport in Bhopal</h6>
                            </div>
                            <div className='content'>
                                {isTheme === "light" ?  <img src="img/voice-light.svg" alt="message" /> :  <img src="img/messagedownload.svg" alt="message" /> }
                                <img src="img/messagedelete.svg" alt="message" />
                            </div>
                        </div>
                        <div className='todaydiv'>
                            <div className='content'>
                            {isTheme === "light" ?  <img src="img/messenger-light.svg" alt="message" /> :  <img src="img/chatmessage.svg" alt="message" />}
                                <h6 className='m-0'>Show me water bodies near airport in Bhopal</h6>
                            </div>
                            <div className='content'>
                            {isTheme === "light" ?  <img src="img/voice-light.svg" alt="message" /> :  <img src="img/messagedownload.svg" alt="message" /> }
                                <img src="img/messagedelete.svg" alt="message" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ChatHistory
